import React from 'react'
import { Flex, Input, ActionIcon, Group, Box, Title, Text } from '@mantine/core'
import { HiX, HiSearch } from "react-icons/hi";

export const PageHeader = ({ title, subtitle, searchValue, onSearchChange, onSearchClick, onClear, placeholder = "Buscar..." }) => {
  return (
    <Flex direction={{ base: 'column', md: 'row' }} justify="space-between" align={{ base: 'flex-start', md: 'center' }} mb="lg" px="md">
      <Box>
        <Title order={ 1 } c="dark.5">{title}</Title>
        {subtitle && <Text c="dimmed" size="sm" fw={500}>{subtitle}</Text>}
      </Box>
      
      <Group align="center" gap="xs" mt={{ base: 'md', md: 0 }}>
        <Input
          variant="filled"
          size="md"
          radius="md"
          placeholder={placeholder}
          value={ searchValue }
          onChange={ (e) => onSearchChange(e.target.value) }
          w={250}
          rightSection={
            searchValue ? (
              <ActionIcon variant="subtle" color="gray" onClick={onClear} size="sm">
                <HiX />
              </ActionIcon>
            ) : null
          }
        />
        <ActionIcon size="lg" onClick={onSearchClick}>
          <HiSearch />
        </ActionIcon>
      </Group>
    </Flex>
  );
};
